<template>
  <router-view/>
</template>

<script>

import axios from 'axios';
import { useToast } from "vue-toastification";
import { mapActions } from 'vuex';

export default {
  name: 'App',
  setup() {
      const toast = useToast();
      return { toast }
  },
  components: {
  },
  methods: {
    ...mapActions('user', {
      logout: 'logout'
    })
  },
  created: function () {
    let self = this;
    axios.interceptors.response.use(response => response, function (error) {

      // error.response é undefined em timeout, queda de rede e falha de CORS.
      const status = error.response !== undefined && error.response !== null
        ? error.response.status
        : null;

      if (status === 401) {
        self.logout();
        if (self.$route.path !== '/login') {
          self.$router.push('/login');
        }
      }

      if (status === 403) {
        self.toast.error("Você não tem permissão para acessar esta página!");
        self.$router.go(-1);
      }

      // Sempre rejeitar: resolver com error.response fazia o erro chegar
      // aos .then() como se fosse sucesso.
      return Promise.reject(error);
    });
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  background: linear-gradient(180deg, #065f46 0%, #047857 50%, #059669 100%);
}

body {
  margin: 0;
  padding: 0;
  background: linear-gradient(180deg, #065f46 0%, #047857 50%, #059669 100%);
}
</style>
